const MONTHES = [
    'Jan', 'Feb', 'Mar', 'Apr', 'Apr', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];
export function formatDate (timestamp) {
    const date = new Date(timestamp);
    return date.getDate() + ' ' + MONTHES[date.getMonth()];
}

export function formatDateWithYear (timestamp) {
    const date = new Date(timestamp);
    return date.getDate() + ' ' + MONTHES[date.getMonth()] + ' ' + date.getFullYear();
}
